export default __webpack_public_path__ + "static/media/Rollback.f23b673e.png";